// extracted by mini-css-extract-plugin
export var expanded = "zwVEP";
export var modeContainer = "sX6Ci";
export var upNextRoot = "NkFok";